import { Service } from 'common/src/types/enums/Service.enum';

export interface MonthlyCostSummary {
  id: number;
  period: string;
  month: number;
  cost: number;
}

export interface MonthlyFacilityCost {
  totalCosts: number;
  facilityName: string;
  id: string;
  services: [Service];
}

/**
 * @name method date formatter
 * @description change the date ISO date format to MMMM yyyy or similar
 * @param {Date} date
 * @param {DateTimeFormatOptions} options
 * @returns
 */
export function dateFormatter(
  date: Date,
  options: any = { month: 'long', year: 'numeric' },
): string {
  const formatter = new Intl.DateTimeFormat('en-US', options).format;
  return formatter(date);
}
